import type { TFunction } from 'i18next';
import dayjs from 'dayjs';

type FormatBookingDate = (
    booking: { start: string; end: string },
    t: TFunction,
) => string;

const capitalize = (str: string): string => str.charAt(0).toUpperCase() + str.slice(1);

export const formatBookingDate: FormatBookingDate = ({ start, end }, t) => {
    const bookingDate = dayjs.utc(start);
    const today = dayjs.utc().startOf('day');

    const diff = bookingDate.diff(today, 'day');

    switch (diff) {
        case 0:
            return `${t('Today')} ${dayjs.utc(start).format('HH:mm')}–${dayjs.utc(end).format('HH:mm')} UTC`;
        case 1:
            return `${t('Tomorrow')} ${dayjs.utc(start).format('HH:mm')}–${dayjs.utc(end).format('HH:mm')} UTC`;
        case 2:
        case 3:
        case 4:
        case 5:
        case 6: {
            const dayName = dayjs.utc(start).format('dddd');
            return `${capitalize(dayName)} ${dayjs.utc(start).format('HH:mm')}–${dayjs.utc(end).format('HH:mm')} UTC`;
        }
        default:
            return `${dayjs.utc(start).format('DD MMM HH:mm')}–${dayjs.utc(end).format('HH:mm')} UTC`;
    }
};
